<template>

  <div class="app-container">
    <div class="back-box">
        <div @click="handleBack">
          <img src="@/assets/back.png" alt="返回" />
          <span>返回</span>
        </div>
  </div>
    <el-card class="box-card">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="分享人" prop="realName" align="center" />
        <el-table-column label="身份" prop="userIdentity" align="center" />
        <el-table-column label="手机号" prop="userPho" align="center" />
        <el-table-column label="是否编辑内容" align="center">
          <template slot-scope="{row}">
            {{ row.isEdited === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="浏览量" prop="browseNum" align="center" />
        <el-table-column label="点赞量" prop="likeNum" align="center" />
        <el-table-column label="转发量" prop="forwardNum" align="center" />
        <el-table-column label="分享时间" prop="shareTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">查看内容</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import templateMaterialsShareAnalyzeApi from '@/api/marketing/templateMaterialsShareAnalyze'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination
  },
  props: ['rowItem'],
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        id: null,
        sourceType: 1 // 1=物料分享的，2=物料分享分析的
      },
      selectItems: []
    }
  },
  created() {
    // 从 rowItem 中获取 id，如果有 sourceType 也获取
    if (this.rowItem) {
      this.query.id = this.rowItem.id || (this.rowItem.templateMaterialsSharePO && this.rowItem.templateMaterialsSharePO.id)
      // 默认 sourceType 为 1（物料分享），如果是从其他页面跳转过来的可以设置
      this.query.sourceType = this.rowItem.sourceType || 1
    }
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleShow(row) {
      // 传递包含 id 的对象给详情页
      const rowData = { ...row, id: row.id || this.query.id }
      this.$emit('handleShow', rowData, 2)
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'shareTime': 'shareTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // 确保 id 存在
      if (!this.query.id) {
        this.$common.showMsg('warning', '缺少分享物料ID')
        return
      }
      this.listLoading = true
      return templateMaterialsShareAnalyzeApi.getForwardList(this.query)
        .then(data => {
          this.list = data.data.list || []
          this.total = data.data.total || 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }

  }
}
</script>
